// extracted by mini-css-extract-plugin
export var avatar = "_re-3";
export var avatarContainer = "_re-2";
export var avatarSpacer = "_re-5";
export var avatarSpacerContainer = "_re-4";
export var avatarStackContainer = "_re-1";
export var bubble = "_re-0";
export var remainderBubble = "_re-6";